import script from "./VirtualSettingUpdatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualSettingUpdatePage.vue?vue&type=script&setup=true&lang=js"

import "./VirtualSettingUpdatePage.vue?vue&type=style&index=0&id=68f4610a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f4610a"]])

export default __exports__